'use client';

import { ReactNode, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { IconButton } from '../buttons';
import { ImageSliderContainer, ImageSwiperContainer, ImageNavigationContainer } from './styles';

import 'swiper/css';
import 'swiper/css/navigation';

interface ImageSliderProps {
    images: ReactNode[];
}

const ImageSlider = ({ images }: ImageSliderProps) => {
    const swiperRef = useRef<SwiperType | null>(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const handlePrev = () => {
        swiperRef.current?.slidePrev();
    };

    const handleNext = () => {
        swiperRef.current?.slideNext();
    };

    const updateNavigationState = (swiper: SwiperType) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };

    if (images.length === 0) return null;

    return (
        <ImageSliderContainer>
            <ImageSwiperContainer>
                <Swiper
                    modules={[Navigation]}
                    slidesPerView={'auto'}
                    spaceBetween={0}
                    centeredSlides={false}
                    touchReleaseOnEdges={true}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                        updateNavigationState(swiper);
                    }}
                    onSlideChange={(swiper) => {
                        updateNavigationState(swiper);
                    }}
                >
                    {images.map((image, index) => (
                        <SwiperSlide key={index} style={{ height: 'auto' }}>{image}</SwiperSlide>
                    ))}
                </Swiper>
            </ImageSwiperContainer>
            <ImageNavigationContainer>
                <IconButton
                    icon={<KeyboardArrowLeft />}
                    onClick={handlePrev}
                    disabled={isBeginning}
                />
                <IconButton
                    icon={<KeyboardArrowRight />}
                    onClick={handleNext}
                    disabled={isEnd}
                />
            </ImageNavigationContainer>
        </ImageSliderContainer>
    );
};

export { ImageSlider };
